<template>
    <div role="contentinfo" class="uw-footer">

        <a href="http://www.washington.edu" class="footer-wordmark">University of Washington</a>

        <p>© {{currentYear}} University of Washington  |  Seattle, WA</p>

    </div>
        
    
</template>

<script>
    
    export default {
        name: 'UWFooter',
        data: function () {
            return {
                currentYear: (new Date()).getFullYear()
            }
        }
    }
</script>

<style scoped> 
	.uw-footer {
		background-color:#4b2e83;
		bottom: 0;
		color: white;
		height: 8rem;
		padding-top: 1rem;
		text-align: center;
		width: 100%;
	}

	
	.footer-wordmark {
		background: url(../assets/svg/uw-sprite.svg) no-repeat 0 -434px transparent;
		display: block;
		text-indent: -9999px;
		width: 335px;
		overflow: hidden;
		text-align: center;
		margin-top: 20px;
		margin-left: auto;
		margin-right: auto;
		position: static;
		/* z-index: 1; */
	}
	.footer-wordmark:hover {
		background: url(../assets/svg/uw-sprite-focus.svg) no-repeat 0 -434px transparent;
	}
</style>